import { Component } from '@angular/core';

@Component({
  selector: 'app-error-401',
  templateUrl: './error401.component.html',
  styleUrls: []
})
export class Error401Component {

}
